import { Button } from 'src/ui/white-labels/techcontemporary/atoms/button';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
    margin-top: 15px;
`;